export const migrateUserError = action => {
  const message = action.payload.toString();

  if (message.includes('409::')) {
    return 'migrate.user.error.duplicate';
  }

  return message;
};
